<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
                   [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle"
  [status]="status"
  [msg]="statusMsg" [token]="token">

  <ng-container *ngIf="consulta">


    <div class="row">
      <div class="p-2 col-12 col-md-4">
        <div class="text-secondary">Histórico de consultas </div>
        <div>{{consulta?.quantidadeDeRegistros || "NÃO INFORMADO"}}</div>
      </div>
      <div class="p-2 col-12 col-md-4">
        <div class="text-secondary">UF Emplacamento inicial </div>
        <div>{{consulta?.uf || "NÃO INFORMADO"}}</div>
      </div>
      <div class="p-2 col-12 col-md-4">
        <div class="text-secondary">Mês do licenciamento </div>
        <div>{{consulta?.mesLicenciamento || "NÃO INFORMADO"}}</div>
      </div>
    </div>

  </ng-container>

</app-card-consulta>
